<template>
  <div class="wrapper app_header" :class="{ sticky: sticky }">
    <div class="header_box box1">
      <div class="showsize">
        <div class="btn header_left">
          <div class="head_img can_click" @click="linkJump(2, '/')">
            <img src="@/assets/common/logo.png" alt="" />
          </div>
          <div class="nav_box" ref="nav_box">
            <div
              class="navItem"
              :class="{ navActive: $route.meta.navName == 'Home' }"
              @click="linkJump(2, '/')"
            >
              <div class="menu_text">主页</div>
            </div>
            <div
              class="navItem"
              :class="{ navActive: $route.meta.navName == 'Artbuying' }"
              @click="linkJump(2, '/Artbuying')"
            >
              <div class="menu_text">艺术品租赁及购买</div>
            </div>
               <div
              class="navItem"
              :class="{ navActive: $route.meta.navName == 'Example' }"
              @click="linkJump(2, '/Example')"
            >
              <div class="menu_text">艺术品定制</div>
            </div>
            <div
              class="navItem"
              :class="{ navActive: $route.meta.navName == 'ArtworkPeriphery' }"
              @click="linkJump(2, '/ArtworkPeriphery')"
            >
              <div class="menu_text">艺术品周边</div>
            </div>
            <div
              class="navItem"
              :class="{ navActive: $route.meta.navName == 'AboutUs' }"
              @click="linkJump(2, '/AboutUs')"
            >
              <div class="menu_text">关于我们</div>
            </div>
          </div>
          <div style="display:flex;align-items:center;">
            <img
              @click="linkJump(2, '/Search', '')"
              style="width:0.083rem;height:0.083rem;cursor:pointer;"
              src="../assets/common/search.png"
              alt=""
            />
            <div style="margin-left:0.1354rem;">
              <a style="cursor:pointer;" href="http://www.hippoart.com/en"
                >EN</a
              >
            </div>
          </div>
        </div>
      </div>
      <div class="btn header_left popup_box">
        <img class="popup_logo" src="@/assets/Aboutart/image_104.png" alt="" />
        <div class="popup_box_right">
          <div> <a href="http://www.hippoart.com/en">EN</a></div>
          <img
            @click="
              jump();
              linkJump(2, '/Search', '');
            "
            src="@/assets/Aboutart/search.png"
            alt=""
          />
          <img
            @click="popupshow = true"
            src="@/assets/Aboutart/popup.png"
            alt=""
          />
        </div>
      </div>

      <!-- <div class="btn header_right can_click" v-if="token">
        <el-badge :is-dot="redPoint" class="badge_item">
          <i class="el-icon-bell" style @click="linkJump('/UserInfo/MyMessages');"></i>
        </el-badge>
        <div @click="show = !show">
          <span>个人中心</span>
          <img
            style="width:14px;height:14px;margin-left:10px;"
            src="@/assets/details/pull-down.png"
            alt
          />
        </div>
      </div> -->
      <!-- <div class="btn header_right can_click" v-else>
        <div class="btn login_btn" @click="toLogin">登录</div>
        <div class="login_bar"></div>
        <div class="btn register_btn" @click="linkJump('/register')">注册</div>
      </div> -->
      <!-- <div class="header_drop" v-if="token">
        <div :class="show ? 'header_drop_down' : 'header_drop_down1'">
          <div class="header_drop_down_title">
            <div class="title_name">{{ detail.CompanyNameFirst }}</div>
            <div class="title_firm">
              <div>{{ detail.companyName }}</div>
              <div>{{ detail.usci }}</div>
            </div>
          </div>
          <div>
            <div
              v-for="(item, index) in options"
              :key="item.index"
              class="header_drop_down_jump"
              @mouseover="mouseOver(index)"
              @mouseout="imgShow = null"
              @click="labelJump(item)"
            >
              <div class="flex">
                <img v-if="imgShow != index" class="header_drop_down_jump_img" :src="item.img1" alt />
                <img v-else class="header_drop_down_jump_img" :src="item.img2" alt />
                <span :class="imgShow === index ? 'activeTitle' : 'Title'">
                  {{
                  item.label
                  }}
                </span>
              </div>
              <img
                v-if="imgShow != index"
                class="header_drop_down_jump_arrows"
                src="@/assets/details/arrows.png"
                alt
              />
              <img
                v-else
                class="header_drop_down_jump_arrows"
                src="@/assets/details/active-arrows.png"
                alt
              />
            </div>
          </div>
        </div>
      </div> -->
    </div>
    <van-popup
      v-model="popupshow"
      closeable
      position="right"
      :style="{ height: '100%', width: '60%' }"
      ref="popup"
    >
      <div class="mobile_flex">
        <div
          @click="
            jump();
            linkJump(2, '/');
          "
        >
          主页
        </div>
        <div
          @click="
            jump();
            linkJump(2, '/Artbuying');
          "
        >
          艺术品租赁及购买
        </div>
           <div
          class="navItem"
          @click="
            jump();
            linkJump(2, '/Example');
          "
        >
          艺术品定制
        </div>
        <div
          class="navItem"
          @click="
            jump();
            linkJump(2, '/ArtworkPeriphery');
          "
        >
          艺术品周边
        </div>
        <div
          @click="
            jump();
            linkJump(2, '/AboutUs');
          "
        >
          关于我们
        </div>
      </div>
    </van-popup>
    <transition name="el-zoom-in-top" mode="out-in">
      <login
        v-if="loginStatus"
        :loginStatus="loginStatus"
        :statusType="type"
        v-on:childByValue="childByValue"
      ></login>
    </transition>
  </div>
</template>
<script>
// import ElMenu from 'element-ui/packages/menu' //测试源码用
import {
  getStore,
  setStore,
  removeStore,
  setSession,
  getSession,
} from "@/utils/auth";
import {
  getBanner,
  getSearchCat,
  // getNavigation,
  getIntroductionForHome,
  getHotWords,
  getInformation,
} from "@/api/home";
import { getTabsCats } from "@/api/Service/Service";
// import { getUnreadNumber } from "@/api/Home/unread.js";
import login from "@/views/login";
import Utils from "@/utils/util";
// import icon1 from "@/assets/images/header/net.png"
export default {
  components: {
    login,
    // 'el-menu':ElMenu
  },
  data() {
    return {
      popupshow: false,
      screenWidthL: null,
      show: true,
      imgShow: null,
      unreadNumber: 0,
      lock: false,
      activeName: "0",
      pullDownShow: false,
      activeIndex: "",
      value: "",
      hotTags: [],
      introduction: "",
      searchContent: "",
      catType: 1,
      catName: 1,
      catList: [],
      navList: [
        {
          name: "交易大厅",
          clickType: 0,
          tableRoute: "/Project",
          routerName: "ProjectHall",
          linkUrl: "",
          children: [
            {
              name: "项目成果",
              clickType: 1,
              tableRoute: "/Project/Outcome",
              routerName: "Outcome",
              linkUrl: "",
              children: null,
            },
            {
              name: "技术需求",
              clickType: 1,
              tableRoute: "/Project/Requirement",
              routerName: "Requirement",
              linkUrl: "",
              children: null,
            },
            {
              name: "技术悬赏",
              clickType: 1,
              tableRoute: "/Project/Reward",
              routerName: "Reward",

              linkUrl: "",
              children: null,
            },
            {
              name: "成交公示",
              clickType: 1,
              tableRoute: "/Project/Deal",
              routerName: "Deal",
              linkUrl: "",
              children: null,
            },
          ],
        },
        {
          name: "服务专区",
          clickType: 1,
          tableRoute: "Service",
          routerName: "Service",
          linkUrl: "",
          children: [
            {
              name: "高校院所",
              clickType: 1,
              tableRoute: "/Service/VipUnit?authType=3&activeNav=0",
              routerName: "VipUnit3",
              linkUrl: "",
              children: null,
            },
            {
              name: "科研机构",
              clickType: 1,
              tableRoute: "/Service/VipUnit?authType=4&activeNav=1",
              routerName: "VipUnit4",
              linkUrl: "",
              children: null,
            },
            {
              name: "技术经理人",
              clickType: 1,
              tableRoute: "/Service/VipUnit?authType=5&activeNav=2",
              routerName: "VipUnit5",
              linkUrl: "",
              children: null,
            },
            {
              name: "代理机构",
              clickType: 1,
              tableRoute: "/Service/VipUnit?authType=6&activeNav=3",
              routerName: "Outcome",
              linkUrl: "",
              children: null,
            },
            {
              name: "机构规则",
              clickType: 1,
              tableRoute: `/Service/ServiceRules`,
              routerName: "ServiceRules",
              linkUrl: "",
              children: null,
            },
          ],
        },
        {
          name: "竞价交易",
          clickType: 0,
          tableRoute: "/Competitive",
          routerName: "Competitive",
          linkUrl: "",
          children: [],
        },
        // {
        //   name: "服务大厅",
        //   clickType: 0,
        //   tableRoute: "Service",
        //   routerName: "Service",
        //   linkUrl: "",
        //   children: [],
        // },
        {
          name: "资产证券",
          clickType: 1,
          tableRoute: "/AssetList",
          routerName: "AssetList",
          linkUrl: "",
          children: [],
        },
        {
          name: "活动中心",
          clickType: 0,
          tableRoute: "Activity",
          routerName: "Activity",
          linkUrl: "",
          children: [],
        },
        {
          name: "政策资讯",
          clickType: 0,
          tableRoute: "Policy",
          routerName: "Policy",
          linkUrl: "",
          children: [
            {
              name: "政策一览",
              clickType: 1,
              tableRoute: "/Recommendation",
              routerName: "Recommendation",
              linkUrl: "",
              children: null,
            },
            {
              name: "新闻动态",
              clickType: 1,
              tableRoute: "/News",
              routerName: "News",
              linkUrl: "",
              children: null,
            },
            {
              name: "视点洞察",
              clickType: 1,
              tableRoute: "/Views",
              routerName: "Views",
              linkUrl: "",
              children: null,
            },
          ],
        },
        {
          name: "关于我们",
          clickType: 0,
          tableRoute: "/Introduction",
          routerName: "Introduction",
          linkUrl: "",
          children: [],
        },
      ],
      bannerData: [], // 顶部轮播图数据
      loginStatus: false,
      type: null,
      // userInfo: getStore("userInfo") ? JSON.parse(getStore("userInfo")) : "",
      userInfo: {},
      sticky: false,
      token: getStore("token"),
      nowTime: "",
      week: "",
      stickyList: ["/userInfo/index", "/reset/password"],
      clickStatus: false,
      navStatus: "Home",
      carNum: "12",
      btnGroup: [
        {
          label: "注册登录",
          icon: "net",
          bg: "#2FB0DD",
          router: "/login",
        },
        {
          label: "服务",
          icon: "heart",
          bg: "#93C14E",
          children: [],
        },
        {
          label: "资源",
          icon: "plant",
          bg: "#F09442",
          children: [],
        },
        {
          label: "资讯",
          icon: "map",
          bg: "#426FF0",
          children: [],
        },
      ],
      searchData: {
        searchStr: this.$route.query.searchStr,
        type: this.$common.isEmpty(this.$route.query.type)
          ? ""
          : this.$route.query.type * 1,
      },
      options: [
        {
          label: "基础信息",
          link: "/UserInfo",
        },
        {
          label: "政策管理",
          link: "/UserInfo/MyCompetitive",
        },
        {
          label: "密码修改",
          link: "/forget",
        },
        {
          label: "退出登录",
          link: "",
        },
      ],
      detail: {
        companyName: "",
        CompanyNameFirst: "",
        usci: "",
      },
    };
  },
  methods: {
    mouseOver(index) {
      this.imgShow = index;
    },
    labelJump(item) {
      if (item.link) {
        this.show = !this.show;
        this.linkJump(item.link);
      } else {
        this.logout();
      }
    },
    jump() {
      document.documentElement.scrollTop = document.body.scrollTop = 0;
      this.popupshow = false;
    },
    checkMessage() {
      this.$router.push({
        path: "/UserInfo/UnRead",
      });
    },
    async getInformation() {
      const res = await getInformation();
      if (res.code === 200) {
        this.detail = res.data;
        this.detail.CompanyNameFirst = this.detail.companyName.substr(0, 1);
        setStore("userInfo", JSON.stringify(res.data));
      }
    },
    testME() {
      console.log("testME");
    },
    setLock(status) {
      console.log("setLock", status);
      this.lock = status;
      if (!status) {
        this.showPullDown(false, this.activeName);
      }
    },
    handleClick() {
      console.log(this.activeName);
      this.showPullDown(true);
    },
    moveEnter(e) {
      console.log("moveEnter", e);
    },
    moveLeave(e) {
      console.log("moveLeave", e);
    },
    showPullDown(e, active) {
      this.activeName = active;
      console.log("moveOver", e);
      if (e) {
        this.pullDownShow = true;
      } else {
        setTimeout(() => {
          if (!this.lock) {
            this.pullDownShow = false;
          }
        }, 500);
      }
    },
    // 跳转搜索
    toSearch() {
      console.log(this.searchData);
      this.$router.push({
        path: "/Search",
        query: {
          searchStr: this.searchData.searchStr,
          type: this.$common.isEmpty(this.searchData.type)
            ? 1
            : this.searchData.type,
        },
      });
      // setStore("type", this.searchData.type);
      // setStore("searchStr", this.searchData.searchStr);
    },
    toSearchHot(str) {
      this.searchData.searchStr = str;
      this.toSearch();
    },
    // 关键词搜索
    async getHotWords() {
      let res = await getHotWords();
      this.hotTags = res.data;
    },
    toRequirement() {
      this.$router.push({ path: "/PublishRequirement" });
    },
    calcIndex(index) {
      switch (index) {
        case 1:
          return 1;
        case 2:
          return 0;
        case 3:
          return 2;
        default:
          break;
      }
    },
    handleSelect(key, keyPath) {
      console.log(key, keyPath);
      this.showPullDown();
      // console.log(this.$refs.theMenu);
      // console.log(this.$route.meta.navName);
      // console.log(this.$route.query.id);
      this.$refs.theMenu.activeIndex =
        this.$route.meta.navName +
        (this.$route.query.id ? this.$route.query.id : "");
      // this.$nextTick(()=>{

      //   this.activeIndex = '/'
      // })
      console.log("当前活动页面activeIndex", this.activeIndex);
    },
    changeType(val) {
      console.log(val);
      this.catType = val;
    },
    // 检索
    toCat(catType) {
      console.log(catType);
      let routeData = this.$router.resolve({
        path: "/Search",
        query: {
          catType: catType,
          searchContent: this.searchContent,
        },
      });
      window.open(routeData.href);
      this.searchContent = "";
      this.catType = catType;
    },
    async getSearchCatOptions() {
      const { data } = await getSearchCat();
      this.catList = data;
    },
    // async getNavigationTree(){
    //   const {data} = await getNavigation()
    //   this.navList = data
    //   this.btnGroup[1].children = this.navList[1].children
    //   this.btnGroup[2].children = this.navList[0].children
    //   this.btnGroup[3].children = this.navList[2].children
    // },

    routerTo(name) {
      // this.navStatus = name;
      setSession("navStatus", name);
      this.navStatus = getSession("navStatus");
      if (name == "result") {
        this.$router.push({ path: "/ResultHome" });
      } else if (name == "server") {
        this.$router.push({ path: "/ServerHome" });
      } else if (name == "source") {
        this.$router.push({ path: "/SourceHome" });
      } else if (name == "policy") {
        this.$router.push({ path: "/PolicyHome" });
      } else if (name !== "Home") {
        this.$router.push("TheForm");
      } else {
        this.$router.push("/");
      }
    },
    handleCommand(command) {
      this[command]();
    },
    logout() {
      localStorage.removeItem("token");
      this.token = getStore("token");
      this.token = "";
      removeStore("userInfo");
      this.getUserInfo();
      this.$router.push("/");
    },
    resetPassword() {
      console.log("reset");
      this.$router.push("/reset/password");
    },
    goHome() {
      this.$router.push("/");
    },
    toLogin() {
      this.$router.push("/login");
      // this.type = type;
      // if (type == 1) {
      //   this.clickStatus = false;
      // } else {
      //   this.clickStatus = true;
      // }
      // this.loginStatus = true;
      // setStore("historyUrl", this.$route.fullPath);
    },
    childByValue(childValue) {
      this.token = getStore("token");
      console.log(this.token);
      // childValue就是子组件传过来的值
      this.loginStatus = childValue;
    },
    toUserInfo() {
      this.$router.push({
        path: "/userInfo",
      });
    },
    handleScroll() {
      let t = document.documentElement.scrollTop; // || window.pageYOffset || document.body.scrollTop;   // 目前监听的是整个body的滚动条距离
      console.log(t);
      console.log(this);
    },
    // 获取轮播图
    getBannerList() {
      let that = this;
      getBanner()
        .then(function(response) {
          if (response.code == 1) {
            that.bannerData = response.data;
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    async getIntroductionForHomeData() {
      const { data } = await getIntroductionForHome();
      console.log("introduction", data);
      this.introduction = data.theDesc;
    },
    async getTabs() {
      const { data } = await getTabsCats();
      let childrenList = [];
      data.map((cat) => {
        let data = {
          name: cat.catName,
          clickType: 1,
          tableRoute: `/Service/ServiceCats?catId=${cat.id}`,
          routerName: "ServiceCats" + cat.id,
          linkUrl: "",
          children: null,
        };
        childrenList.push(data);
      });
      let rulesData = {
        name: "机构规则",
        clickType: 1,
        tableRoute: `/Service/ServiceRules`,
        routerName: "ServiceRules",
        linkUrl: "",
        children: null,
      };
      childrenList.push(rulesData);
      this.navList[3].children = childrenList;
    },
  },
  watch: {
    $route(newValue) {
      console.log(newValue);
      this.searchData.searchStr = newValue.query.searchStr;
      this.searchData.type = this.$common.isEmpty(newValue.query.type)
        ? ""
        : newValue.query.type * 1;
      this.activeIndex = newValue.fullPath;
      console.log(this.activeIndex);
      if (this.stickyList.indexOf(this.$route.path) !== -1) {
        this.sticky = true;
      } else {
        this.sticky = false;
      }
      console.log("sticky", this.sticky);
    },
  },
  created() {
    // if (getStore("token")) {
    //   this.getInformation();
    // }
    // console.log(getStore("userInfo"));
    // console.log("header路由", this.$route);
    // console.log(
    //   this.$route.meta.navName +
    //     (this.$route.query.id ? this.$route.query.id : "")
    // );
    // if (this.token) {
    //   getUnreadNumber().then((res) => {
    //     this.unreadNumber = res.data;
    //   });
    // }
    // this.getTabs();
    // this.getActivityTabs();
    // this.getIntroductionForHomeData();
    // this.getSearchCatOptions();
    // this.getNavigationTree()
    // this.getBannerList();
    // if (!this.$common.isEmpty(getSession("navStatus"))) {
    //   this.navStatus = getSession("navStatus");
    // } else {
    //   this.navStatus = "Home";
    // }
    // if (this.stickyList.indexOf(this.$route.path) !== -1) {
    //   this.sticky = true;
    // } else {
    //   this.sticky = false;
    // }
    // if (!this.$common.isEmpty(getStore('type'))){
    //   this.searchData.type = getStore('type')*1
    // } else {
    //   this.searchData.type = ""
    // }
    // console.log(this.searchData.type);
    // if (!this.$common.isEmpty(getStore('searchStr'))){
    //   this.searchData.searchStr = getStore('searchStr')
    // } else {
    //   this.searchData.searchStr = ""
    // }
  },
  mounted() {
    let that = this;
    Utils.$on("toLogin", function(msg) {
      that.toLogin(msg);
    });
    // this.getHotWords();
    this.$EventBus.$on("childByValue", this.childByValue);
    //监听窗口宽度
    window.addEventListener("resize", this.screenWidth);
    console.log("resize", this.screenWidth);
  },
  beforeDestroy() {
    this.$EventBus.$off("childByValue", this.childByValue);
    this.popupshow = false;
  },
};
</script>

<style lang="less" scoped>
@import "~@/static/styles/variables.less";
@import "~@/static/styles/index.less";

.wrapper {
  // position: relative;
  //// min-width: @commentWidth;;
  background-color: #ffffff;
  font-family: PingFang-SC;
  position: absolute;
  top: 0px;
  z-index: 10;
  background: transparent;
  width: 100%;
  .pull_down {
    display: flex;
    justify-content: center;
    align-items: flex-start;
    position: absolute;
    top: 66px;
    width: 100vw;
    height: 242px;
    background-color: #fff;
    z-index: 999;

    .pull_down_item {
      padding: 30px;
      min-width: 200px;
      display: flex;
      flex-direction: column;
      align-items: center;

      .label {
        margin-bottom: 26px;
        font-size: 16px;
        font-weight: 400;
        color: linear-gradient(90deg, #68a4ff 0%, #166df0 100%);
        line-height: 19px;
      }

      .line {
        margin-bottom: 16px;
        font-size: 14px;
        font-weight: 400;
        color: #646566;
        line-height: 16px;

        &:hover {
          color: linear-gradient(90deg, #68a4ff 0%, #166df0 100%);
          text-decoration: underline;
        }
      }
    }
  }

  .header_box {
    position: relative;
    background-size: 100% 100%;
    .header_left {
      padding: 0 1.25rem;
      height: 0.4479rem;
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: 16px;
      font-weight: 400;
      color: #323233;
      line-height: 19px;

      .head_img {
        width: 0.4323rem;
        height: 0.2813rem;
        display: flex;
      }

      img {
        width: 0.4323rem;
        height: 0.2813rem;
      }
    }
    .popup_box {
      padding: 0.4rem;
      height: 0.72rem;
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: 16px;
      font-weight: 400;
      color: #323233;
      line-height: 19px;
      backdrop-filter: blur();
      background: radial-gradient(
        100% 800% at 0% 30%,
        rgb(203 191 255) 0%,
        rgb(217 246 255) 40%,
        rgb(195 224 255) 100%
      );
      position: fixed;
      width: -webkit-fill-available;
      .popup_logo {
        width: 1.12rem;
        height: 0.72rem;
      }
      .popup_box_right {
        display: flex;
        align-items: center;
        gap: 0.4533rem;
        img {
          width: 0.6133rem;
          height: 0.6133rem;
        }
        :first-child {
          // margin-right: 0.4rem;
          font-family: Source-Regular;
          font-weight: 400;
          font-size: 0.48rem;
          color: #333333;
        }
      }
    }
    .header_right {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 34px;
      border-radius: 17px;
      // span {
      font-size: 16px;
      font-weight: 400;
      color: #323233;
      line-height: 19px;
      .login_btn,
      .register_btn {
        font-size: 14px;
        font-weight: 400;
        color: #999999;
        line-height: 16px;
      }
      .login_bar {
        width: 1px;
        height: 11px;
        margin: 0 10px;
        background-color: #999999;
      }
      // }
      .head-unread {
        position: relative;
        width: 28px;
        height: 28px;
        margin-left: 20px;
        margin-right: 20px;
      }

      .head-unread-number {
        opacity: 0.8;
        text-align: center;
        line-height: 18px;
        font-size: 12px;
        color: white;
        position: absolute;
        right: -3px;
        top: -2px;
        width: 18px;
        height: 18px;
        border-radius: 50%;
        background-color: red;
      }

      .shop_icon {
        width: 28px;
        height: 28px;
      }
    }

    .nav_box {
      display: flex;
      font-size: 16px;
      font-weight: bold;
      color: #6c6c6c;

      .navItem {
        position: relative;
        padding: 0.0677rem 0.0417rem;
        margin-left: 0.1563rem;
        cursor: pointer;
        &:hover {
          color: linear-gradient(90deg, #68a4ff 0%, #166df0 100%);
        }
        .menu_text {
          font-size: 0.1042rem;
          color: #333333;
          line-height: 0.2448rem;
          font-weight: 400;
          font-family: Source-Regular;
        }
      }

      .navActive {
        color: linear-gradient(90deg, #68a4ff 0%, #166df0 100%);
        &::after {
          content: "";
          position: absolute;
          bottom: 0.0729rem;
          left: 50%;
          transform: translateX(-50%);
          display: block;
          width: 0.1667rem;
          height: 0.0156rem;
          background: linear-gradient(to right, #64a2fe, #176ef0);
        }
      }
    }

    .carImg {
      width: 35px;
      height: 35px;
      cursor: pointer;
    }

    .userImg {
      width: 40px;
      height: 40px;
      border-radius: 50%;
      margin-right: 10px;
      cursor: pointer;
    }

    .user_info {
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .theInfo {
      font-size: 14px;
      font-weight: 400;
      color: #7d7d7d;
      line-height: 20px;

      .user_name {
        font-size: 14px;
        font-weight: 400;
        color: linear-gradient(90deg, #68a4ff 0%, #166df0 100%);
        line-height: 20px;
      }
    }

    .header_bar {
      margin: 0 13px 0 10px;
      width: 1px;
      height: 10px;
      background-color: #26262696;
    }

    .my_center {
      font-size: 14px;
      font-weight: 400;
      color: #262626;
      line-height: 20px;
    }

    .login_box {
      display: flex;
      align-items: center;

      .loginBtn {
        width: 80px;
        height: 35px;
        background: #ffffff;
        border-radius: 8px;
        font-size: 16px;
        font-weight: 400;
        line-height: 35px;
        text-align: center;
        margin-right: 50px;
        cursor: pointer;
      }

      .loginActive {
        width: 80px;
        height: 35px;
        background: #19caad;
        color: #ffffff;
        border-radius: 8px;
        font-size: 16px;
        font-weight: 400;
        line-height: 35px;
        text-align: center;
        margin-right: 50px;
        cursor: pointer;
      }
    }
  }

  .box1 {
    height: 0.4479rem;
  }

  .box2 {
    box-sizing: border-box;
    padding: 20px 0;
    max-width: 100vw;
    width: 100vw;
    height: 110px;
    background-color: #fff;

    .box_inner {
      width: @commentWidth;
      margin: 0 auto;
      display: flex;
      align-items: flex-start;
      justify-content: flex-start;
    }

    .header_img {
      width: 203px;
      height: 34px;

      img {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
    }

    .header_search {
      margin-left: 89px;
      .normal_flex;
      .fd_column;
      align-items: flex-start;

      .search_wrap {
        .normal_flex;

        .btn {
          margin-left: 16px;
        }
      }

      .search_input {
        width: 568px;
        height: 40px;
        background: #f5f8fd;
        border-radius: 25px;
        .normal_flex;

        ::v-deep {
          input {
            background-color: transparent;
            border: none;
          }
        }

        ::v-deep {
          .el-input--prefix {
            .el-input__inner {
              padding-left: 50px;
            }
          }
        }

        .search_bar {
          width: 1px;
          height: 18px;
          background-color: #26262666;
        }

        .search_btn {
          width: 50px;
          font-size: 15px;
          font-weight: bold;
          color: linear-gradient(90deg, #68a4ff 0%, #166df0 100%);
          margin-right: 24px;
          cursor: pointer;
        }
      }

      .hot {
        margin-top: 10px;

        .label {
          margin-left: 20px;
          font-size: 12px;
          font-weight: 400;
          color: linear-gradient(90deg, #68a4ff 0%, #166df0 100%);
          line-height: 17px;
        }

        .tag {
          margin-left: 15px;
          font-size: 12px;
          font-weight: 300;
          color: #262626;
          line-height: 17px;
          cursor: pointer;
        }
      }
    }
  }

  .box3 {
    height: 56px;
  }

  .search_box {
    // box-sizing: border-box;
    width: 100%;
    height: 450px;
    background: linear-gradient(
      270deg,
      #35d2c3 0%,
      #34cfc6 10%,
      #34cbc8 20%,
      #33c8cb 30%,
      #32c4ce 40%,
      #32c1d1 50%,
      #31bed3 60%,
      #30bad6 70%,
      #2fb7d9 80%,
      #2fb3db 90%,
      #2eb0de 100%
    );
    padding-top: 20px;

    .search_content {
      margin: 0 auto;
      max-width: @commentWidth;
      height: 100%;
      display: flex;

      .search_left {
        position: relative;
        width: 813px;

        // background-color: #123;
        .title {
          position: absolute;
          top: 50%;
          margin-top: -20px;
          left: 30px;
          font-size: 28px;
          font-weight: 400;
          color: #ffffff;
          line-height: 40px;
          letter-spacing: 2px;
          -webkit-background-clip: text;
        }

        .search {
          z-index: 10;
          position: absolute;
          bottom: 80px;
          left: 30px;
          flex: 1;
          background: rgba(255, 255, 255, 1);
          // border-radius: 6px;
          // border: 1px solid #94dbcf;
          // text-align: center;
          font-size: 16px;
          font-weight: bold;
          color: #19caad;

          span {
            cursor: pointer;
          }
        }
      }

      .search_right {
        flex: 1;
        flex-direction: column;
        background-color: #fff;

        .description {
          box-sizing: border-box;
          height: 297px;
          padding: 30px;

          .title {
            width: auto;
            font-size: 20px;
            font-weight: bold;
            line-height: 28px;
            color: #333333;
            border-bottom: 1px solid #19caad;
          }

          .desc {
            margin: 20px 0;
            font-size: 14px;
            font-weight: 400;
            line-height: 22px;
            color: #333333;
            .text_overflow_hidden_lines(5);
          }
        }

        .service_group {
          flex: 1;
          display: flex;
          flex-wrap: wrap;

          .service_btn {
            cursor: pointer;
            box-sizing: border-box;
            width: 50%;
            height: 77px;
            display: flex;
            justify-content: flex-start;
            align-items: center;
            color: #fff;

            .service_inner {
              width: 100%;
              height: 100%;
              padding: 0 0 0 47px;
            }

            img {
              width: 33px;
              height: 33px;
            }

            span {
              margin-left: 10px;
              color: #fff;
              font-size: 16px;
              font-weight: 500;
            }
          }
        }
      }
    }
  }
  .header_drop {
    position: absolute;
    top: 66px;
    right: 0;
    z-index: 99;
    width: 265px;
    height: 270px;
    overflow: hidden;

    .header_drop_down {
      width: 217px;
      height: 260px;
      background: #fff;
      position: absolute;
      border-radius: 6px 6px 6px 6px;
      transition: opacity 0.5s ease-in-out;
      overflow: hidden;
      padding: 0px 24px;
      box-shadow: 0px 2px 26px -1px rgba(0, 0, 0, 0.08);
      margin-top: -100%;
      opacity: 0.6;
      transition: all 0.4s;
    }
    .header_drop_down1 {
      width: 217px;
      height: 260px;
      background: #fff;
      position: absolute;
      border-radius: 6px 6px 6px 6px;
      transition: opacity 0.5s ease-in-out;
      overflow: hidden;
      padding: 0px 24px;
      box-shadow: 0px 2px 26px -1px rgba(0, 0, 0, 0.08);
      margin-top: 0;
      opacity: 1;
      transition: all 0.4s;
      margin-top: 10px;
    }
    .header_drop_down_title {
      display: flex;
      padding: 24px 0 16px 0;
      border-bottom: 1px solid #f0f0f0;
      align-items: center;
      .title_name {
        width: 48px;
        height: 48px;
        background: linear-gradient(90deg, #68a4ff 0%, #166df0 100%);
        border-radius: 50%;
        font-size: 20px;
        font-weight: 500;
        color: #ffffff;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-right: 8px;
      }
      .title_firm {
        width: 150px;
        :first-child {
          font-size: 16px;
          font-weight: 500;
          line-height: 21px;
          color: #333333;
        }
        :last-child {
          font-size: 12px;
          font-weight: 400;
          color: #999999;
          line-height: 20px;
        }
      }
    }
    .header_drop_down_jump {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 16px;
      cursor: pointer;

      .Title {
        font-size: 14px;
        font-weight: 400;
        color: #666666;
        margin-left: 6px;
      }
      .activeTitle {
        font-size: 14px;
        font-weight: 400;
        color: linear-gradient(90deg, #68a4ff 0%, #166df0 100%);
        margin-left: 6px;
      }
      .header_drop_down_jump_img {
        width: 21px;
        height: 21px;
      }
      .header_drop_down_jump_arrows {
        width: 10px;
        height: 10px;
      }
    }
    .flex {
      display: flex;
      align-items: center;
    }
  }
  .mobile_flex {
    padding: 1.0667rem 0.5333rem;
    display: flex;
    flex-direction: column;
    row-gap: 1.0667rem;
    margin-top: 2.6667rem;
    div {
      font-family: Source-Regular;
      font-weight: 400;
      font-size: 0.3733rem;
      color: #333333;
      text-align: center;
    }
  }
  @media screen and (max-width: 1024px) {
    .showsize {
      display: none;
    }
  }
  @media screen and (min-width: 1024px) {
    .popup_box {
      display: none !important;
    }
  }
}
</style>
<style lang="less">
.wrapper {
  .el-badge__content {
    padding: 0 2px;
    border: none;
  }

  .el-badge__content.is-fixed {
    position: absolute;
    top: 10px;
    right: 15px;
  }
}

.search {
  .el-input__inner {
    border: none;
    font-size: 16px;
    font-weight: 500;
    color: #737373;
    height: 54px;
    line-height: 54px;
  }

  .el-input-group__prepend div.el-select .el-input__inner {
    color: #19caad;
    font-size: 16px;
    font-weight: bold;
    line-height: 54px;
  }

  .el-icon-caret-right:before {
    font-size: 16px;
  }

  .el-input-group__append,
  .el-input-group__prepend {
    border: none;
    background-color: #fff;
    border-right: 1px dashed #ced3d7;
    // width: 35%;
    width: 135px;
    padding-left: 0;
    padding-right: 0;
    // border-radius: 32px;
    // float: left;
  }

  .el-select .el-input .el-select__caret {
    color: #19caad;
  }

  .el-input-group__append .el-button,
  .el-input-group__append .el-select,
  .el-input-group__prepend .el-button,
  .el-input-group__prepend .el-select {
    margin: 0;
  }

  .el-button--success {
    height: 54px;
    background-color: #46b942;
    border: 1px solid #46b942;
    float: right;
  }
}

.app_header {
  .el-carousel__indicators--horizontal {
    right: 20px;
    left: none;
    transform: translateX(0);
  }

  .el-carousel__arrow {
    display: none;
  }
}

.nav_box {
  // background-color: #123;
  .el-menu {
    background-color: transparent;
  }

  .el-submenu {
    .el-submenu__title {
      height: 66px;
      line-height: 66px;
    }
  }

  .el-menu-item {
    margin: 0 20px;
  }

  .el-menu-item,
  .el-submenu__title {
    font-size: 16px;
    // margin: 0 20px;
    height: 66px;
    line-height: 66px;
  }

  .el-menu.el-menu--horizontal {
    border: none;
  }
}

.beautiful_hover {
  &:hover {
    background-color: #fafbfe;
    color: linear-gradient(90deg, #68a4ff 0%, #166df0 100%);
  }
}
</style>
